// extracted by mini-css-extract-plugin
export var active = "_et-2";
export var recordingDot = "_et-1";
export var recordingIndicator = "_et-0";